import React, { useContext, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { Can } from "../Can";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Box, Divider, IconButton, Menu, ListItemIcon, ListItemText, Typography } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { DeviceHubOutlined, History, Replay, SwapHorizOutlined, Phone, MoreVert, CheckCircle, Close, ChatBubbleOutline } from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmationModal from "../ConfirmationModal";
import * as Yup from "yup";
import { Formik } from "formik";
import Dialog from '@material-ui/core/Dialog';
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";

//icones
import EventIcon from "@material-ui/icons/Event";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import UndoIcon from '@material-ui/icons/Undo';

import ScheduleModal from "../ScheduleModal";
import MenuItem from "@material-ui/core/MenuItem";
import { Switch } from "@material-ui/core";
import ShowTicketOpen from "../ShowTicketOpenModal";
import { toast } from "sonner";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import ShowTicketLogModal from "../../components/ShowTicketLogModal";

const GreenSwitch = withStyles({
    switchBase: {
        color: "#ccc",
        "&$checked": {
            color: "#0B3C84",
        },
        "&$checked + $track": {
            backgroundColor: "#0B3C84",
        },
    },
    checked: {},
    track: {},
})(Switch);

const useStyles = makeStyles(theme => ({
    actionButtons: {
        marginRight: 6,
        maxWidth: "100%",
        flex: "none",
        alignSelf: "center",
        marginLeft: "auto",
        display: "flex",
        alignItems: "center",
        gap: 4,
    },
    moreButton: {
        padding: 6,
        color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
        borderRadius: 8,
        transition: "all 0.2s ease",
        "&:hover": {
            backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "#F1F5F9",
            color: theme.palette.type === "dark" ? "#E2E8F0" : "#1E293B",
        },
    },
    audioSwitchContainer: {
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: "2px 6px",
        borderRadius: 8,
        backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#F8FAFC",
        border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "#E2E8F0"}`,
    },
    audioSwitchDivider: {
        height: 20,
        margin: "0 4px",
        backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.12)" : "#E2E8F0",
    },
    actionIconBtn: {
        padding: 4,
        color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
        "&:hover": {
            backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#E2E8F0",
            color: theme.palette.type === "dark" ? "#E2E8F0" : "#475569",
        },
    },
    actionIconBtnDanger: {
        padding: 4,
        color: theme.palette.type === "dark" ? "#F87171" : "#EF4444",
        "&:hover": {
            backgroundColor: theme.palette.type === "dark" ? "rgba(248,113,113,0.12)" : "#FEF2F2",
        },
    },
    audioLabel: {
        fontFamily: '"Inter", "Poppins", sans-serif',
        fontSize: "0.7rem",
        fontWeight: 500,
        color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
        whiteSpace: "nowrap",
    },
    menuPaper: {
        borderRadius: 12,
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
        minWidth: 220,
        border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "#E2E8F0"}`,
    },
    menuItem: {
        fontFamily: '"Inter", "Poppins", sans-serif',
        fontSize: 14,
        padding: "10px 16px",
        gap: 4,
        borderRadius: 6,
        margin: "2px 6px",
        transition: "all 0.15s ease",
        "&:hover": {
            backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9",
        },
    },
    menuIcon: {
        minWidth: 32,
        color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    },
    menuIconActive: {
        minWidth: 32,
        color: "#0B3C84",
    },
    menuText: {
        "& .MuiTypography-root": {
            fontFamily: '"Inter", "Poppins", sans-serif',
            fontSize: 13,
            fontWeight: 500,
        },
    },
    menuItemWithSwitch: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    },
    menuDivider: {
        margin: "4px 12px",
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9",
    },
    botoes: {
        display: "flex",
        padding: "15px",
        justifyContent: "flex-end",
        maxWidth: "100%",
        gap: 8,
    },
    acceptBtn: {
        fontFamily: '"Inter", "Poppins", sans-serif',
        fontWeight: 600,
        fontSize: 13,
        borderRadius: 8,
        padding: "6px 16px",
        textTransform: "none",
        backgroundColor: "#0B3C84",
        color: "#FFFFFF",
        "&:hover": {
            backgroundColor: "#082D63",
        },
    },
    dangerMenuItem: {
        color: theme.palette.type === "dark" ? "#F87171" : "#EF4444",
        "&:hover": {
            backgroundColor: theme.palette.type === "dark" ? "rgba(239, 68, 68, 0.08)" : "#FEF2F2",
        },
    },
    resolveModalPaper: {
        borderRadius: 12,
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
        border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "#E2E8F0"}`,
    },
    resolveModalContent: {
        display: "flex",
        flexDirection: "column",
        gap: 12,
        padding: 24,
        alignItems: "stretch",
    },
    resolveModalOptionsRow: {
        display: "flex",
        flexDirection: "row",
        gap: 16,
        justifyContent: "center",
        flexWrap: "wrap",
    },
    resolveModalOption: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        padding: 20,
        minWidth: 160,
        borderRadius: 12,
        border: "1px solid #0B3C84",
        backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.02)" : "transparent",
        cursor: "pointer",
        fontFamily: '"Inter", "Poppins", sans-serif',
        transition: "all 0.2s ease",
        "&:hover": {
            backgroundColor: theme.palette.type === "dark" ? "rgba(11, 60, 132, 0.08)" : "rgba(11, 60, 132, 0.06)",
            borderColor: "#082D63",
        },
    },
    resolveModalOptionIcon: {
        color: "#0B3C84",
        fontSize: 36,
    },
    resolveModalOptionText: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
    },
    resolveModalOptionTitle: {
        fontFamily: '"Inter", "Poppins", sans-serif',
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.type === "dark" ? "#E2E8F0" : "#1E293B",
    },
    resolveModalOptionSubtitle: {
        fontFamily: '"Inter", "Poppins", sans-serif',
        fontSize: 12,
        fontWeight: 500,
        color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    },
    resolveModalTitle: {
        fontFamily: '"Inter", "Poppins", sans-serif',
        fontWeight: 600,
        fontSize: 16,
    },
}));

const SessionSchema = Yup.object().shape({
    ratingId: Yup.string().required("Avaliação obrigatória"),
});

const TicketActionButtonsCustom = ({ ticket }) => {

    const classes = useStyles();
    const history = useHistory();
    const isMounted = useRef(true);
    const [loading, setLoading] = useState(false);
    const { user } = useContext(AuthContext);
    const { setCurrentTicket } = useContext(TicketsContext);
    const [open, setOpen] = React.useState(false);
    const formRef = React.useRef(null);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
    const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
    const [contactId, setContactId] = useState(null);
    const [acceptAudioMessage, setAcceptAudio] = useState(ticket.contact.acceptAudioMessage);
    const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);
    const [showTicketLogOpen, setShowTicketLogOpen] = useState(false);
    const [showSchedules, setShowSchedules] = useState(false);
    const [enableIntegration, setEnableIntegration] = useState(ticket.useIntegration);

    // Three-dots menu anchor
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const menuOpen = Boolean(menuAnchorEl);

    const [openAlert, setOpenAlert] = useState(false);
    const [userTicketOpen, setUserTicketOpen] = useState("");
    const [queueTicketOpen, setQueueTicketOpen] = useState("");
    const [logTicket, setLogTicket] = useState([]);

    const { get: getSetting } = useCompanySettings()
    const { getPlanCompany } = usePlans();

    useEffect(() => {
        async function fetchData() {
            const companyId = user.companyId;
            const planConfigs = await getPlanCompany(undefined, companyId);
            setShowSchedules(planConfigs.plan.useSchedules);
        }
        fetchData();
        setShowTicketLogOpen(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const handleClickOpen = async (e) => {
        handleMenuClose();
        const setting = await getSetting({
            "column": "requiredTag"
        });

        if (setting?.requiredTag === "enabled") {
            try {
                const contactTags = await api.get(`/contactTags/${ticket.contact.id}`);
                if (!contactTags.data.tags) {
                    toast.warning(i18n.t("messagesList.header.buttons.requiredTag"))
                } else {
                    setOpen(true);
                }
            } catch (err) {
                toastError(err);
            }
        } else {
            setOpen(true);
        }
    };

    const handleClose = () => {
        formRef.current.resetForm();
        setOpen(false);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
        setLoading(false);
    };
    const handleOpenAcceptTicketWithouSelectQueue = async () => {

        setAcceptTicketWithouSelectQueueOpen(true);

    };

    const handleOpenScheduleModal = () => {
        handleMenuClose();
        if (typeof handleClose == "function") handleClose();
        setContactId(ticket.contact.id);
        setScheduleModalOpen(true);
    }

    const handleCloseScheduleModal = () => {
        setScheduleModalOpen(false);
        setContactId(null);
    }



    const handleOpenTransferModal = (e) => {
        handleMenuClose();
        setTransferTicketModalOpen(true);
        if (typeof handleClose == "function") handleClose();
    };

    const handleOpenConfirmationModal = (e) => {
        handleMenuClose();
        setConfirmationOpen(true);
        if (typeof handleClose == "function") handleClose();
    };


    const handleCloseTicketWithoutFarewellMsg = async () => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "closed",
                userId: user?.id || null,
                sendFarewellMessage: false,
                amountUsedBotQueues: 0
            });

            setLoading(false);
            history.push("/tickets");
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleEnableIntegration = async () => {
        handleMenuClose();
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                useIntegration: !enableIntegration
            });
            setEnableIntegration(!enableIntegration)

            setLoading(false);
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleShowLogTicket = async () => {
        handleMenuClose();
        setLoading(true);
        try {
            const { data } = await api.get(`/tickets-log/${ticket.id}`);
            setLogTicket(data);
            setShowTicketLogOpen(true);

            setLoading(false);
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleContactToggleAcceptAudio = async () => {
        try {
            const contact = await api.put(`/contacts/toggleAcceptAudio/${ticket.contact.id}`);
            setAcceptAudio(contact.data.acceptAudioMessage);
        } catch (err) {
            toastError(err);
        }
    };

    const handleCloseTransferTicketModal = () => {
        if (isMounted.current) {
            setTransferTicketModalOpen(false);
        }
    };

    const handleDeleteTicket = async () => {
        try {
            await api.delete(`/tickets/${ticket.id}`);
        } catch (err) {
            toastError(err);
        }
    };

    const handleSendMessage = async (id) => {
        const msg = `{{ms}} *{{name}}*, ${i18n.t("mainDrawer.appBar.user.myName")} *${user?.name}* ${i18n.t("mainDrawer.appBar.user.continuity")}.`;
        const message = {
            read: 1,
            fromMe: true,
            mediaUrl: "",
            body: `*${i18n.t("mainDrawer.appBar.user.virtualAssistant")}:*\n${msg.trim()}`,
        };
        try {
            await api.post(`/messages/${id}`, message);
        } catch (err) {
            toastError(err);
        }
    };

    const handleUpdateTicketStatus = async (e, status, userId) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: status,
                userId: userId || null,
            });

            let setting;

            try {
                setting = await getSetting({
                    "column": "sendGreetingAccepted"
                })
            } catch (err) {
                toastError(err);
            }

            if (setting?.sendGreetingAccepted === "enabled" && (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled") && ticket.status === "pending") {
                handleSendMessage(ticket.id);
            }

            setLoading(false);
            if (status === "open" || status === "group") {
                setCurrentTicket({ ...ticket, code: "#" + status });
                history.push(`/tickets/${ticket.uuid}`);
            } else {
                setCurrentTicket({ id: null, code: null })
                history.push("/tickets");
            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleAcepptTicket = async (id) => {
        setLoading(true);
        try {
            const otherTicket = await api.put(`/tickets/${id}`, {
                status: ticket.isGroup ? "group" : "open",
                userId: user?.id,
            });
            if (otherTicket.data.id !== ticket.id) {
                if (otherTicket.data.userId !== user?.id) {
                    setOpenAlert(true)
                    setUserTicketOpen(otherTicket.data.user.name)
                    setQueueTicketOpen(otherTicket.data.queue.name)
                } else {
                    setLoading(false);
                    history.push(`/tickets/${otherTicket.data.uuid}`);
                }
            } else {
                if (isMounted.current) {
                    setLoading(false);
                }
                setCurrentTicket({ ...otherTicket.data, code: "#" + otherTicket.data.status });
                history.push(`/tickets/${ticket.uuid}`);
            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleOpenWavoipCall = () => {
        handleMenuClose();

        console.log(ticket);

        if (!ticket?.whatsapp?.wavoip || !ticket?.contact?.number) {
            toastError("Erro: Token ou número de telefone não disponível.");
            return;
        }

        const token = ticket.whatsapp.wavoip;
        const phone = ticket.contact.number.replace(/\D/g, "");
        const name = `${ticket.contact.name} #${ticket.id}`;
        const url = `https://app.wavoip.com/call?token=${token}&phone=${phone}&name=${name}&start_if_ready=true&close_after_call=true`;

        window.open(url, "wavoip", "toolbar=no,scrollbars=no,resizable=no,top=500,left=500,width=500,height=700");
    };

    const handleReturnToQueue = (e) => {
        handleMenuClose();
        handleUpdateTicketStatus(e, "pending", null);
    };


    return (
        <>
            <ShowTicketOpen
                isOpen={openAlert}
                handleClose={handleCloseAlert}
                user={userTicketOpen}
                queue={queueTicketOpen}
            />
            <AcceptTicketWithouSelectQueue
                modalOpen={acceptTicketWithouSelectQueueOpen}
                onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
                ticketId={ticket.id}
                ticket={ticket}
            />
            <ShowTicketLogModal
                isOpen={showTicketLogOpen}
                handleClose={(e) => setShowTicketLogOpen(false)}
                logs={logTicket}
            />
            <div className={classes.actionButtons}>

                {/* Reopen buttons for closed tickets - stay visible */}
                {ticket.status === "closed" && (ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                        loading={loading}
                        startIcon={<Replay />}
                        size="small"
                        className={classes.acceptBtn}
                        onClick={e => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                        {i18n.t("messagesList.header.buttons.reopen")}
                    </ButtonWithSpinner>
                )}
                {(ticket.status === "closed" && ticket.queueId !== null) && (
                    <ButtonWithSpinner
                        startIcon={<Replay />}
                        loading={loading}
                        className={classes.acceptBtn}
                        onClick={e => handleAcepptTicket(ticket.id)}
                    >
                        {i18n.t("messagesList.header.buttons.reopen")}
                    </ButtonWithSpinner>
                )}

                {/* Open/Group ticket: Audio switch + three-dots menu */}
                {(ticket.status === "open" || ticket.status === "group") && (
                    <>
                        {/* Transferir, Resolver e Switch de áudio na barra */}
                        <div className={classes.audioSwitchContainer}>
                            <Tooltip title={i18n.t("ticketOptionsMenu.transfer")} arrow placement="bottom">
                                <IconButton size="small" className={classes.actionIconBtn} onClick={handleOpenTransferModal}>
                                    <SwapHorizOutlined style={{ fontSize: 18 }} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={i18n.t("messagesList.header.buttons.resolve")} arrow placement="bottom">
                                <IconButton size="small" className={classes.actionIconBtn} onClick={handleClickOpen}>
                                    <CheckCircle style={{ fontSize: 18 }} />
                                </IconButton>
                            </Tooltip>
                            <Divider orientation="vertical" className={classes.audioSwitchDivider} />
                            <Typography className={classes.audioLabel}>
                                {i18n.t("ticketOptionsMenu.acceptAudioMessage")}
                            </Typography>
                            <GreenSwitch
                                size="small"
                                checked={acceptAudioMessage}
                                onChange={() => handleContactToggleAcceptAudio()}
                            />
                        </div>

                        {/* Three-dots menu button */}
                        <IconButton
                            className={classes.moreButton}
                            onClick={handleMenuOpen}
                            size="small"
                        >
                            <MoreVert />
                        </IconButton>

                        <Menu
                            anchorEl={menuAnchorEl}
                            open={menuOpen}
                            onClose={handleMenuClose}
                            PaperProps={{
                                className: classes.menuPaper,
                            }}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                        >
                            <MenuItem className={classes.menuItem} onClick={handleOpenWavoipCall}>
                                <ListItemIcon className={classes.menuIcon}>
                                    <Phone fontSize="small" />
                                </ListItemIcon>
                                <ListItemText className={classes.menuText}>Ligação</ListItemText>
                            </MenuItem>

                            <MenuItem className={classes.menuItem} onClick={handleShowLogTicket}>
                                <ListItemIcon className={classes.menuIcon}>
                                    <History fontSize="small" />
                                </ListItemIcon>
                                <ListItemText className={classes.menuText}>
                                    {i18n.t("messagesList.header.buttons.logTicket")}
                                </ListItemText>
                            </MenuItem>

                            <MenuItem className={classes.menuItem} onClick={handleEnableIntegration}>
                                <ListItemIcon className={enableIntegration ? classes.menuIconActive : classes.menuIcon}>
                                    <DeviceHubOutlined fontSize="small" />
                                </ListItemIcon>
                                <ListItemText className={classes.menuText}>
                                    {i18n.t("messagesList.header.buttons.enableIntegration")}
                                    {enableIntegration && (
                                        <Typography variant="caption" style={{ color: "#0B3C84", marginLeft: 6, fontWeight: 600 }}>
                                            Ativo
                                        </Typography>
                                    )}
                                </ListItemText>
                            </MenuItem>

                            {showSchedules && (
                                <MenuItem className={classes.menuItem} onClick={handleOpenScheduleModal}>
                                    <ListItemIcon className={classes.menuIcon}>
                                        <EventIcon fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText className={classes.menuText}>
                                        {i18n.t("tickets.buttons.scredule")}
                                    </ListItemText>
                                </MenuItem>
                            )}

                            <MenuItem className={classes.menuItem} onClick={handleReturnToQueue}>
                                <ListItemIcon className={classes.menuIcon}>
                                    <UndoIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText className={classes.menuText}>
                                    {i18n.t("tickets.buttons.returnQueue")}
                                </ListItemText>
                            </MenuItem>

                            <Can
                                role={user.profile}
                                perform="ticket-options:deleteTicket"
                                yes={() => (
                                    <MenuItem
                                        className={`${classes.menuItem} ${classes.dangerMenuItem}`}
                                        onClick={handleOpenConfirmationModal}
                                    >
                                        <ListItemIcon className={classes.menuIcon} style={{ color: "inherit" }}>
                                            <DeleteOutlineIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText className={classes.menuText}>
                                            {i18n.t("tickets.buttons.deleteTicket")}
                                        </ListItemText>
                                    </MenuItem>
                                )}
                            />
                        </Menu>

                        <ConfirmationModal
                            title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")} #${ticket.id}?`}
                            open={confirmationOpen}
                            onClose={setConfirmationOpen}
                            onConfirm={handleDeleteTicket}
                        >
                            {i18n.t("ticketOptionsMenu.confirmationModal.message")}
                        </ConfirmationModal>
                        <TransferTicketModalCustom
                            modalOpen={transferTicketModalOpen}
                            onClose={handleCloseTransferTicketModal}
                            ticketid={ticket.id}
                            ticket={ticket}
                        />
                        <ScheduleModal
                            open={scheduleModalOpen}
                            onClose={handleCloseScheduleModal}
                            aria-labelledby="form-dialog-title"
                            contactId={contactId}
                        />

                    </>
                )}

                {/* Accept buttons for pending tickets - stay visible */}
                {ticket.status === "pending" && (ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                        loading={loading}
                        size="small"
                        variant="contained"
                        className={classes.acceptBtn}
                        onClick={e => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                        {i18n.t("messagesList.header.buttons.accept")}
                    </ButtonWithSpinner>
                )}
                {ticket.status === "pending" && ticket.queueId !== null && (
                    <ButtonWithSpinner
                        loading={loading}
                        size="small"
                        variant="contained"
                        className={classes.acceptBtn}
                        onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
                    >
                        {i18n.t("messagesList.header.buttons.accept")}
                    </ButtonWithSpinner>
                )}
            </div>
            <>
                <Formik
                    enableReinitialize={true}
                    validationSchema={SessionSchema}
                    innerRef={formRef}
                    onSubmit={(values, actions) => {
                        setTimeout(() => {
                            actions.setSubmitting(false);
                            actions.resetForm();
                        }, 400);
                    }}
                >
                    {({ values, touched, errors, isSubmitting, setFieldValue, resetForm }) => (
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="resolve-modal-title"
                            PaperProps={{ className: classes.resolveModalPaper }}
                        >
                            <DialogTitle id="resolve-modal-title" className={classes.resolveModalTitle}>
                                {i18n.t("messagesList.header.resolveModalTitle")}
                            </DialogTitle>
                            <DialogContent className={classes.resolveModalContent}>
                                <Box className={classes.resolveModalOptionsRow}>
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        className={classes.resolveModalOption}
                                        onClick={() => {
                                            handleClose();
                                            handleCloseTicketWithoutFarewellMsg();
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                handleClose();
                                                handleCloseTicketWithoutFarewellMsg();
                                            }
                                        }}
                                    >
                                        <Close className={classes.resolveModalOptionIcon} />
                                        <div className={classes.resolveModalOptionText}>
                                            <Typography className={classes.resolveModalOptionTitle}>
                                                {i18n.t("messagesList.header.resolveLabel")}{" "}
                                                <strong>{i18n.t("messagesList.header.resolveWithout")}</strong>
                                            </Typography>
                                            <Typography className={classes.resolveModalOptionSubtitle}>
                                                {i18n.t("messagesList.header.resolveFarewellLine")}
                                            </Typography>
                                        </div>
                                    </div>
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        className={classes.resolveModalOption}
                                        onClick={() => {
                                            handleClose();
                                            handleUpdateTicketStatus(null, "closed", user?.id);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                handleClose();
                                                handleUpdateTicketStatus(null, "closed", user?.id);
                                            }
                                        }}
                                    >
                                        <ChatBubbleOutline className={classes.resolveModalOptionIcon} />
                                        <div className={classes.resolveModalOptionText}>
                                            <Typography className={classes.resolveModalOptionTitle}>
                                                {i18n.t("messagesList.header.resolveLabel")}{" "}
                                                <strong>{i18n.t("messagesList.header.resolveWith")}</strong>
                                            </Typography>
                                            <Typography className={classes.resolveModalOptionSubtitle}>
                                                {i18n.t("messagesList.header.resolveFarewellLine")}
                                            </Typography>
                                        </div>
                                    </div>
                                </Box>
                            </DialogContent>
                        </Dialog>
                    )}
                </Formik>
            </>
        </>
    );
};

export default TicketActionButtonsCustom;
